import { create } from 'zustand';

/**
 * Zustand store for Lessons Learned
 * Manages post-incident review items
 */
export const useLessonsLearnedStore = create((set, get) => ({
    // State
    lessons: [],
    loading: false,
    error: null,

    // Actions
    setLessons: (lessons) => set({ lessons }),

    addLesson: (lesson) => {
        const current = get().lessons;
        const newItem = {
            ...lesson,
            id: lesson.id || Date.now()
        };
        set({ lessons: [...current, newItem] });
        return newItem;
    },

    updateLesson: (updatedLesson) => {
        const current = get().lessons;
        const newLessons = current.map(l => l.id === updatedLesson.id ? updatedLesson : l);
        set({ lessons: newLessons });
        return updatedLesson;
    },

    deleteLesson: (id) => {
        const current = get().lessons;
        set({ lessons: current.filter(l => l.id !== id) });
    },

    // Initialize from crisis object
    initializeFromCrisis: (crisis) => {
        if (crisis?.lessonsLearned) {
            set({ lessons: crisis.lessonsLearned });
        } else {
            set({ lessons: [] });
        }
    },

    clearStore: () => set({ lessons: [], error: null })
}));
